import React, { Fragment } from 'react';
import styled from 'styled-components';
import { TextAreaChange } from '../types';
import Asterisk from './Asterisk';
import ToolTip from './ToolTip';
import { theme } from 'styles/ThemeProvider';

interface Props {
   placeholder?: string;
   label: string;
   name?: string;
   value: string;
   onChange: (e: TextAreaChange) => void;
   required?: boolean;
   errorMessage?: string | false;
}

export default ({ placeholder, label, name, value = '', onChange, required, errorMessage }: Props) => (
   <Fragment>
      <LabelContainer>
         <Label htmlFor={name}>
            {label}
            {required && <Asterisk />}
         </Label>
      </LabelContainer>
      <Container>
         <TextArea placeholder={placeholder} name={name} value={value} onChange={onChange} />
      </Container>
      {errorMessage && <ToolTip color={theme.primaryRed}>{errorMessage}</ToolTip>}
   </Fragment>
);

const Container = styled.div`
   margin: 1em auto;
   position: relative;
   max-width: 400px;
   width: 100%;
   display: inline-block;
`;
const TextArea = styled.textarea.attrs(({ placeholder }) => ({ placeholder }))`
   border: 1px solid ${({ theme }) => theme.primaryGrey};
   border-radius: 10px;
   padding: 14px 7px;
   width: 100%;
   height: 120px;
   font-size: 16px;
   color: ${({ theme }) => theme.almostBlack};
   font-family: inherit;
   -webkit-box-sizing: border-box;
   -moz-box-sizing: border-box;
   box-sizing: border-box;
`;

const LabelContainer = styled.div`
   margin: 0 auto 0.9em auto;
   position: relative;
   margin-top: 1em;
   display: flex;
   justify-content: center;
   align-items: center;
`;

const Label = styled.label`
   font-weight: 600;
   font-size: 1.2em;
   position: absolute;
   left: 75px;
   top: -20px;
   color: ${({ theme }) => theme.primaryBlueDark};
   @media only screen and (max-width: 400px) {
      left: 10px;
   }
`;
